<template>
  <div>
    <div class="mb-4">
      <a href="/" class="flex items-center group py-3">
        <span class="text-gray-300 group-hover:text-white">Home</span>
      </a>
    </div>
    <div class="mb-4">
      <a href="/qc-email" class="flex items-center group py-3">
        <span class="text-gray-300 group-hover:text-white">QC Email</span>
      </a>
    </div>
    <div class="mb-4">
      <a href="/qc-cid" class="flex items-center group py-3">
        <span class="text-gray-300 group-hover:text-white">QC cID</span>
      </a>
    </div>
    <div class="mb-4">
      <a href="/stg-email" class="flex items-center group py-3">
        <span class="text-gray-300 group-hover:text-white">STG Email</span>
      </a>
    </div>
    <div class="mb-4">
      <a href="/stg-cid" class="flex items-center group py-3">
        <span class="text-gray-300 group-hover:text-white">STG cID</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
